/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useState, useEffect } from 'react';
import moment from 'moment';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Autocomplete,
} from '@mui/material';
import { toast } from 'react-toastify';
import Grid from '@mui/material/Unstable_Grid2';
import { DatePicker } from '@mui/x-date-pickers';
import AppConst from '../AppLayout/const';
import {
  getAgendaOptions,
  getProductOptions,
  getSpecialtyOptions,
  getGroupOptions,
  postReportExport,
} from '../../api/productUtilApi';
import { getFilterTeams } from '../../api/medRepApi';

export default function ProductUtilModal() {
  const { toggleModal, onToggleModal } = useContext(AppConst.AppContext);
  const [toggle, setToggle] = useState(false);

  const defaultFilter = {
    from: moment().format('YYYY-MM-01'),
    to: moment().format('YYYY-MM-DD'),
    keyword: '',
    agenda: [{ label: 'ALL', value: null }],
    products: [{ label: 'ALL', value: null }],
    specialty: [{ label: 'ALL', value: null }],
    except_specialty: [],
    team: [{ label: 'ALL', value: null }],
    md_groups: [{ label: 'ALL', value: null }],
    format: {
      label: 'Per DM',
      value: 'per_md',
    },
  };

  // const formatOptions = [
  //   {
  //     label: 'Per DM',
  //     value: 'per_md',
  //   },
  //   {
  //     label: 'Per Specialty',
  //     value: 'per_segment',
  //   },
  // ];
  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [agendaOptions, setAgendaOptions] = useState([]);
  const [specialtyOptions, setSpecialtyOptions] = useState([]);
  const [exceptSpecialtyOptions, setExceptSpecialtyOptions] = useState([]);
  const [groupsOptions, setGroupsOptions] = useState([]);
  const [teamOptions, setTeamOptions] = useState([]);
  const [productsOptions, setProductsOptions] = useState([]);

  // const handleChangeFilter = (e, row, name) => {
  //   setFilterForm({ ...filterForm, [name]: row });
  // };

  const loadTeamsDropdown = async () => {
    const request = {
      department: '',
      manager_id: '',
      date_from: filterForm?.from,
      date_to: filterForm?.to,
      month: [],
      years: [],
      keyword: '',
    };
    const reponse = await getFilterTeams(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = data
        ?.filter((row) => row.team !== null)
        .map((row) => ({
          value: row.team,
          label: row.team,
        }));
      setTeamOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadAgendaDropdown = async () => {
    const request = {
      keyword: '',
    };
    const reponse = await getAgendaOptions(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = data?.map((row) => ({
        value: row.description,
        label: row.description,
      }));

      setAgendaOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadSpecialtyDropdown = async () => {
    const request = {
      keyword: '',
    };
    const reponse = await getSpecialtyOptions(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = data
        ?.filter((row) => row.specialty !== '')
        .map((row) => ({
          value: row.specialty,
          label: row.specialty,
        }));

      setSpecialtyOptions([{ label: 'ALL', value: null }, ...dropdownValue]);

      setExceptSpecialtyOptions([...dropdownValue]);
    }
  };

  const loadGroupaDropdown = async () => {
    const request = {
      keyword: '',
    };
    const reponse = await getGroupOptions(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = data
        ?.filter((row) => row.id !== null)
        .map((row) => ({
          value: row.name,
          label: row.md_group,
        }));

      setGroupsOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadProductsDropdown = async () => {
    const request = {
      agenda: filterForm?.agenda?.map((row) => row.value),
    };
    const reponse = await getProductOptions(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = data?.map((row) => ({
        value: row.product,
        label: row.product,
      }));
      setProductsOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  useEffect(() => {
    if (toggleModal?.url === 'report/product_util') {
      setToggle(true);
      loadAgendaDropdown();
      loadSpecialtyDropdown();
      loadGroupaDropdown();
      loadTeamsDropdown();
    }
  }, [toggleModal]);

  useEffect(() => {
    loadProductsDropdown();
  }, [filterForm.agenda]);

  const handleDateRange = (value, name) => {
    setFilterForm({ ...filterForm, [name]: moment(value).format('YYYY-MM-DD') });
  };

  // const handleExportPerSegment = async () => {
  //   try {
  //     toast.loading('Please wait ...');
  //     const request = {
  //       agenda:
  //         filterForm?.agenda[0].value !== null ? filterForm?.agenda?.map((row) => row.value) : [],
  //       products:
  //         filterForm?.products[0].value !== null
  //           ? filterForm?.products?.map((row) => row.value)
  //           : [],
  //       specialty:
  //         filterForm?.specialty[0].value !== null
  //           ? filterForm?.specialty?.map((row) => row.value)
  //           : [],
  //       except_specialty: filterForm?.except_specialty?.map((row) => row.value),
  //       team: filterForm?.team[0].value !== null ? filterForm?.team?.map((row) => row.value) : [],
  //       md_groups:
  //         filterForm?.md_groups[0].value !== null
  //           ? filterForm?.md_groups?.map((row) => row.value)
  //           : [],
  //       from: filterForm?.from,
  //       to: filterForm?.to,
  //     };
  //     const res = await postPerSegmentExport(request);

  //     const { code, result, message } = res.data.response;
  //     if (code !== '200') {
  //       throw Object.assign(new Error(message), { code: 402 });
  //     }
  //     toast.dismiss();

  //     if (code === '200') {
  //       toast.success(`file has been successfully exported: ${res.data.response.file_name}`);
  //       window.location.href = result;
  //     }
  //   } catch (error) {
  //     toast.dismiss();
  //     toast.error(error.message);
  //   }
  // };
  // const handleExportPerMd = async () => {
  //   try {
  //     toast.loading('Please wait ...');
  //     const request = {
  //       agenda:
  //         filterForm?.agenda[0].value !== null ? filterForm?.agenda?.map((row) => row.value) : [],
  //       products:
  //         filterForm?.products[0].value !== null
  //           ? filterForm?.products?.map((row) => row.value)
  //           : [],
  //       specialty:
  //         filterForm?.specialty[0].value !== null
  //           ? filterForm?.specialty?.map((row) => row.value)
  //           : [],
  //       except_specialty: filterForm?.except_specialty?.map((row) => row.value),
  //       team: filterForm?.team[0].value !== null ? filterForm?.team?.map((row) => row.value) : [],
  //       md_groups:
  //         filterForm?.md_groups[0].value !== null
  //           ? filterForm?.md_groups?.map((row) => row.value)
  //           : [],
  //       from: filterForm?.from,
  //       to: filterForm?.to,
  //     };

  //     const res = await postPerMDExport(request);

  //     const { code, result, message } = res.data.response;
  //     if (code !== '200') {
  //       throw Object.assign(new Error(message), { code: 402 });
  //     }
  //     toast.dismiss();
  //     if (code === '200') {
  //       toast.success(`file has been successfully exported: ${res.data.response.file_name}`);
  //       window.location.href = result;
  //     }
  //   } catch (error) {
  //     toast.dismiss();
  //     toast.error(error.message);
  //   }
  // };

  const handleExportReport = async () => {
    try {
      toast.loading('Please wait ...');
      const request = {
        agenda:
          filterForm?.agenda[0].value !== null ? filterForm?.agenda?.map((row) => row.value) : [],
        products:
          filterForm?.products[0].value !== null
            ? filterForm?.products?.map((row) => row.value)
            : [],
        specialty:
          filterForm?.specialty[0].value !== null
            ? filterForm?.specialty?.map((row) => row.value)
            : [],
        except_specialty: filterForm?.except_specialty?.map((row) => row.value),
        team: filterForm?.team[0].value !== null ? filterForm?.team?.map((row) => row.value) : [],
        md_groups:
          filterForm?.md_groups[0].value !== null
            ? filterForm?.md_groups?.map((row) => row.value)
            : [],
        from: filterForm?.from,
        to: filterForm?.to,
      };

      const res = await postReportExport(request);

      const { code, result, message } = res.data.response;
      if (code !== '200') {
        throw Object.assign(new Error(message), { code: 402 });
      }
      toast.dismiss();
      if (code === '200') {
        toast.success(`file has been successfully exported: ${res.data.response.file_name}`);
        window.location.href = result;
      }
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handleSubmit = () => {
    // if (filterForm?.format?.value === 'per_segment') {
    //   handleExportPerSegment();
    // } else {
    //   handleExportPerMd();
    // }
    handleExportReport();
  };

  const handleCancel = () => {
    onToggleModal(null);
    setToggle(false);
  };

  return (
    <Dialog open={toggle} onClose={handleCancel} maxWidth='sm' fullWidth>
      <DialogTitle>Product Utilizations</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} mb={1}>
          <Grid md={12}>
            <Autocomplete
              id='agenda'
              multiple
              fullWidth
              options={agendaOptions}
              autoComplete
              includeInputInList
              filterSelectedOptions
              getOptionLabel={(option) => (option.label ? option.label : '')}
              value={filterForm.agenda}
              noOptionsText='No Agendas'
              onChange={(e, newValue) => {
                let updatedNewValue = newValue;

                if (newValue.length === 0) {
                  // if remove all month option set default to all
                  updatedNewValue = [agendaOptions[0]];
                } else if (newValue[newValue.length - 1].value === null) {
                  // if last selected in ALL, remove all other options and retain ALL
                  updatedNewValue = [agendaOptions[0]];
                } else if (newValue.length !== 1) {
                  // if selected other months, remove ALL in selected options
                  updatedNewValue = newValue.filter(
                    (option) => option.value !== agendaOptions[0].value,
                  );
                }

                setFilterForm({
                  ...filterForm,
                  agenda: updatedNewValue,
                });
              }}
              isOptionEqualToValue={(option, selected) => option.value === selected.value}
              renderInput={(params) => <TextField {...params} label='Agenda' />}
              renderOption={(props, option) => (
                <li {...props} key={option.value}>
                  {option.label}
                </li>
              )}
              size='small'
            />
          </Grid>
          <Grid md={12}>
            <Autocomplete
              id='specialty'
              multiple
              fullWidth
              options={specialtyOptions}
              autoComplete
              includeInputInList
              filterSelectedOptions
              getOptionLabel={(option) => (option.label ? option.label : '')}
              value={filterForm.specialty}
              noOptionsText='No Specialty'
              onChange={(e, newValue) => {
                let updatedNewValue = newValue;

                if (newValue.length === 0) {
                  // if remove all month option set default to all
                  updatedNewValue = [specialtyOptions[0]];
                } else if (newValue[newValue.length - 1].value === null) {
                  // if last selected in ALL, remove all other options and retain ALL
                  updatedNewValue = [specialtyOptions[0]];
                } else if (newValue.length !== 1) {
                  // if selected other months, remove ALL in selected options
                  updatedNewValue = newValue.filter(
                    (option) => option.value !== specialtyOptions[0].value,
                  );
                }

                setFilterForm({
                  ...filterForm,
                  specialty: updatedNewValue,
                });
              }}
              isOptionEqualToValue={(option, selected) => option.value === selected.value}
              renderInput={(params) => <TextField {...params} label='Specialty' />}
              renderOption={(props, option) => (
                <li {...props} key={option.value}>
                  {option.label}
                </li>
              )}
              size='small'
            />
          </Grid>
          <Grid md={12}>
            <Autocomplete
              id='except_specialty'
              multiple
              fullWidth
              options={exceptSpecialtyOptions}
              autoComplete
              includeInputInList
              filterSelectedOptions
              getOptionLabel={(option) => (option.label ? option.label : '')}
              value={filterForm.except_specialty}
              noOptionsText='No Specialty'
              onChange={(e, newValue) => {
                let updatedNewValue = newValue;

                if (newValue.length === 0) {
                  // if remove all month option set default to all
                  updatedNewValue = [exceptSpecialtyOptions[0]];
                } else if (newValue[newValue.length - 1].value === null) {
                  // if last selected in ALL, remove all other options and retain ALL
                  updatedNewValue = [exceptSpecialtyOptions[0]];
                } else if (newValue.length !== 1) {
                  // if selected other months, remove ALL in selected options
                  updatedNewValue = newValue.filter(
                    (option) => option.value !== exceptSpecialtyOptions[0].value,
                  );
                }

                setFilterForm({
                  ...filterForm,
                  except_specialty: updatedNewValue,
                });
              }}
              isOptionEqualToValue={(option, selected) => option.value === selected.value}
              renderInput={(params) => <TextField {...params} label='Except Specialty' />}
              renderOption={(props, option) => (
                <li {...props} key={option.value}>
                  {option.label}
                </li>
              )}
              size='small'
            />
          </Grid>
          <Grid md={12}>
            <Autocomplete
              id='products'
              multiple
              fullWidth
              options={productsOptions}
              autoComplete
              includeInputInList
              filterSelectedOptions
              getOptionLabel={(option) => (option.label ? option.label : '')}
              value={filterForm.products}
              noOptionsText='No Products'
              onChange={(e, newValue) => {
                let updatedNewValue = newValue;

                if (newValue.length === 0) {
                  // if remove all month option set default to all
                  updatedNewValue = [productsOptions[0]];
                } else if (newValue[newValue.length - 1].value === null) {
                  // if last selected in ALL, remove all other options and retain ALL
                  updatedNewValue = [productsOptions[0]];
                } else if (newValue.length !== 1) {
                  // if selected other months, remove ALL in selected options
                  updatedNewValue = newValue.filter(
                    (option) => option.value !== productsOptions[0].value,
                  );
                }

                setFilterForm({
                  ...filterForm,
                  products: updatedNewValue,
                });
              }}
              isOptionEqualToValue={(option, selected) => option.value === selected.value}
              renderInput={(params) => <TextField {...params} label='Products' />}
              renderOption={(props, option) => (
                <li {...props} key={option.value}>
                  {option.label}
                </li>
              )}
              size='small'
            />
          </Grid>
          <Grid md={12}>
            <Autocomplete
              id='md_groups'
              multiple
              fullWidth
              options={groupsOptions}
              autoComplete
              includeInputInList
              filterSelectedOptions
              getOptionLabel={(option) => (option.label ? option.label : '')}
              value={filterForm.md_groups}
              noOptionsText='No Groups'
              onChange={(e, newValue) => {
                let updatedNewValue = newValue;

                if (newValue.length === 0) {
                  // if remove all month option set default to all
                  updatedNewValue = [groupsOptions[0]];
                } else if (newValue[newValue.length - 1].value === null) {
                  // if last selected in ALL, remove all other options and retain ALL
                  updatedNewValue = [groupsOptions[0]];
                } else if (newValue.length !== 1) {
                  // if selected other months, remove ALL in selected options
                  updatedNewValue = newValue.filter(
                    (option) => option.value !== groupsOptions[0].value,
                  );
                }

                setFilterForm({
                  ...filterForm,
                  md_groups: updatedNewValue,
                });
              }}
              isOptionEqualToValue={(option, selected) => option.value === selected.value}
              renderInput={(params) => <TextField {...params} label='Groups' />}
              renderOption={(props, option) => (
                <li {...props} key={option.value}>
                  {option.label}
                </li>
              )}
              size='small'
            />
          </Grid>
          <Grid md={12}>
            <Autocomplete
              id='team'
              multiple
              fullWidth
              options={teamOptions}
              autoComplete
              includeInputInList
              filterSelectedOptions
              getOptionLabel={(option) => (option.label ? option.label : '')}
              value={filterForm.team}
              noOptionsText='No Team'
              onChange={(e, newValue) => {
                let updatedNewValue = newValue;

                if (newValue.length === 0) {
                  // if remove all month option set default to all
                  updatedNewValue = [teamOptions[0]];
                } else if (newValue[newValue.length - 1].value === null) {
                  // if last selected in ALL, remove all other options and retain ALL
                  updatedNewValue = [teamOptions[0]];
                } else if (newValue.length !== 1) {
                  // if selected other months, remove ALL in selected options
                  updatedNewValue = newValue.filter(
                    (option) => option.value !== teamOptions[0].value,
                  );
                }

                setFilterForm({
                  ...filterForm,
                  team: updatedNewValue,
                });
              }}
              isOptionEqualToValue={(option, selected) => option.value === selected.value}
              renderInput={(params) => <TextField {...params} label='Teams' />}
              renderOption={(props, option) => (
                <li {...props} key={option.value}>
                  {option.label}
                </li>
              )}
              size='small'
            />
          </Grid>
          {/* <Grid md={12}>
            <Autocomplete
              disablePortal
              id='format'
              disableClearable
              fullWidth
              options={formatOptions}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Format' />}
              size='small'
              value={filterForm?.format}
              onChange={(e, newValue) => handleChangeFilter(e, newValue, 'format')}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid> */}
          <Grid lg={6}>
            <DatePicker
              label='from'
              views={['month', 'day', 'year']}
              value={filterForm?.from}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => (
                <TextField {...params} label='From' size='small' fullWidth />
              )}
              onChange={(value) => handleDateRange(value, 'from')}
            />
          </Grid>
          <Grid lg={6}>
            <DatePicker
              label='to'
              views={['month', 'day', 'year']}
              value={filterForm?.to}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='To' size='small' fullWidth />}
              onChange={(value) => handleDateRange(value, 'to')}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit}>Submit</Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
